(function ($) {

  // マウスが載ったらサブメニューを表示
  $("ul#primary-menu li").mouseenter(function () {
    $(this).children().fadeIn(200);     // 自分のサブメニューを表示する。
    $(this).parent().find("ul").addClass("active");
  });

  // マウスが離れたらサブメニューを消す
  $("ul#primary-menu li").mouseleave(function () {
    $(this).parent().find("ul").fadeOut(200);
    $(this).parent().find("ul").removeClass("active");
  });


  $("#primary-menu-sp .sub-menu").hide();
  $("#primary-menu-sp > li.menu-item-has-children").on("click", function () {
    $(this).find(".sub-menu").slideToggle();
    $(this).toggleClass("active");
  });

})(jQuery);
